import LoadingButton from '@mui/lab/LoadingButton'
import {
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@mui/material'

export interface DeletePopupProps {
  loading: boolean
  openDeletePopup: boolean
  deleteEntity?: () => Promise<void> | undefined
  setOpenDeletePopup: (deletePopup: boolean | undefined) => void
  deleteMessage: string | undefined
  deleteError: string | undefined
  warning?: boolean | undefined
  warningMessage?: string | undefined
  canDelete?: boolean | undefined
  setDeleteError?: React.Dispatch<React.SetStateAction<string | undefined>>
}

export function DeletePopup({
  loading,
  openDeletePopup,
  deleteEntity,
  setOpenDeletePopup,
  deleteError,
  deleteMessage,
  warning,
  warningMessage,
  canDelete,
  setDeleteError,
}: DeletePopupProps) {
  //checka á connected entities
  let error = false
  if (deleteError || (warning && canDelete !== true)) {
    error = true
  }
  const handleChange = () => {
    if (setDeleteError) {
      setDeleteError(deleteError ? deleteError : undefined)
    }
    setOpenDeletePopup(false)
  }
  return (
    <Dialog
      fullWidth
      maxWidth='sm'
      open={openDeletePopup}
      PaperProps={{
        sx: { width: '40%', maxWidth: '40%' },
      }}
    >
      <DialogTitle sx={{ pt: 5 }}>Eyða</DialogTitle>
      <DialogContent dividers>
        <DialogContentText sx={{ my: 2 }}>
          {((!warning && !deleteError) || (!deleteError && canDelete)) &&
            deleteMessage}
          {warning && warningMessage}
          {deleteError && deleteError}
        </DialogContentText>
        <DialogActions sx={{ mt: 4, px: 0 }}>
          {!error && (
            <LoadingButton
              loading={loading}
              variant='contained'
              color='secondary'
              onClick={() =>
                deleteEntity !== undefined ? deleteEntity() : null
              }
              sx={{ mr: 2 }}
            >
              Eyða
            </LoadingButton>
          )}
          <Button variant='contained' onClick={() => handleChange()}>
            Til Baka
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  )
}
